import { isValidElement } from 'react';
export const extractTextFromReactNodes = nodes => nodes.map(node => {
  if (typeof node === 'string') {
    return node;
  }
  if (typeof node === 'number') {
    return String(node);
  }
  if ( /*#__PURE__*/isValidElement(node)) {
    const element = node;
    if (element.props.children) {
      const children = Array.isArray(element.props.children) ? element.props.children : [element.props.children];
      return extractTextFromReactNodes(children);
    }
  }
  return '';
}).join('');